import { extendVariants, HeroTextarea as StyledTextarea } from '@cavela/ui';

const Textarea = extendVariants(StyledTextarea, {
  variants: {
    color: {
      default: {
        input: '!bg-white font-medium placeholder:text-gray-6',
        inputWrapper: [
          'shadow-none',
          '!bg-white border-1 border-gray-4',
          'hover:!bg-white',
          'focus-within:!bg-white focus-within:border-foreground',
          '!cursor-text',
          'rounded-lg'
        ],
        label: '!text-secondary-text'
      }
    },
    isInvalid: {
      true: { base: '' }
    },
    isDisabled: {
      true: {
        base: '!opacity-100',
        input: 'placeholder:text-gray-4 !opacity-100',
        inputWrapper: '!bg-gray-1 !opacity-100'
      }
    }
  },
  defaultVariants: {
    color: 'default',
    textSize: 'base',
    placeholder: ' ',
    labelPlacement: 'outside',
    size: 'lg',
    variant: 'bordered'
  }
});

export default Textarea;
